import { TileRoleRoute } from '@/types'
import { Roles } from '@/auth/azure/Roles'
import { faCalendarDay } from '@fortawesome/free-solid-svg-icons'
import { ManagementGridFactory } from '@/routes/admin/components/ManagementGrid/ManagementGridFactory'

export const DumpEventRoute: TileRoleRoute = {
  path: 'dumpEvent',
  text: 'Evento Dump',
  faIcon: faCalendarDay,
  element: (
    <ManagementGridFactory
      entity="tipologia_evento_dump"
      referencesCollection="eventi"
      referencesTitle="Eventi Dump"
      displayField="id"
    />
  ),
  handle: {
    crumb: () => ({
      label: 'Evento Dump',
      icon: faCalendarDay,
    }),
  },
  mainMenuRoute: false,
  tile: true,
  allowedRoles: [Roles.GlobalAdministrator],
}
